import {
  all, call, fork, put, takeEvery,
} from 'redux-saga/effects';

// action creators
import { doneIndicator, error } from '../../actions/httpActions';

// api
import { find } from '../../sources/api/client';
import userSpecialtyService from '../../sources/api/userSpecialtyService';

// constants
import { USER_SPECIALTY_FETCH, USER_SPECIALTY_FETCH_INIT } from '../../constants/userSpecialtyTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { userSpecialtyListSchema } from '../../schemas/userSpecialty';

export function* userSpecialtyFetch(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const { user } = action.payload || {};

  const options = {
    query: {
      user,

      $sort: {
        createdAt: -1,
      },
    },
  };

  try {
    yield* httpSaga(USER_SPECIALTY_FETCH, call(find, userSpecialtyService, options), {
      schema: userSpecialtyListSchema,
    });
  } catch (err) {
    yield put(error(USER_SPECIALTY_FETCH, err));
  } finally {
    yield put(doneIndicator(USER_SPECIALTY_FETCH));
  }
}

export function* watchUserSpecialtyFetch() {
  yield takeEvery(USER_SPECIALTY_FETCH_INIT, userSpecialtyFetch);
}

export default function* root() {
  yield all([
    fork(watchUserSpecialtyFetch),
  ]);
}
